import React, { useRef } from "react"
import { Box } from "@rebass/grid/emotion"

import { TextElementNova } from "@nutrafol/nutrafol-ui-kit/dist/TextElementNova"
import {
  ContainerWithBg,
  HeroDivider,
  HeroDot,
  HeroContainerMobile,
} from "./hero.styled"
import Tabs from "../tabs/tabs"
import { useGSAP } from "@gsap/react"
import gsap from "gsap"

const DEVMODE = process.env.GATSBY_DEVMODE === "1"

const HeroMobile = ({
  data,
  setCoreFade,
  newCore,
  TitleSection,
  BenefitsSection,
  ImagesSectionFn,
}) => {
  const { subheading, pill, tabs } = data
  const dotRef = useRef(null)
  const imgRef = useRef(null)

  useGSAP(() => {
    const mm = gsap.matchMedia()
    const triggerTimeline = (position = 0) => {
      const tl = gsap.timeline()
      // First animation
      tl.to(
        dotRef.current,
        {
          top: "calc(100% - 105px)",
          duration: 0.6,
          ease: "none",
        },
        position
      )
      tl.to(
        imgRef.current,
        {
          transform: "scale(1)",
          duration: 0.6,
          onComplete: () => {
            gsap.killTweensOf(imgRef.current)
            gsap.killTweensOf(dotRef.current)
            dotRef.current.style.display = "none"
          },
          ease: "none",
        },
        position
      )
    }

    mm.add("(max-width: 1279px)", () => {
      const contH = document.querySelector(
        ".mobile-hero-container"
      )?.offsetHeight

      //compensate HeroContainerWrapper top padding
      let topOffset = 174

      if (window.innerWidth > 768) {
        topOffset = 174
      }

      if (window.innerWidth > 1024) {
        topOffset = 198
      }

      gsap.to(dotRef.current, {
        top: "calc(100% - 105px)",
        onComplete: () => {
          gsap.killTweensOf(dotRef.current)
          dotRef.current.style.display = "none"
        },
        scrollTrigger: {
          markers: false,
          onUpdate: (self) => {
            //console.log(self.scroll())
            if (self.scroll() > contH / 2.8) {
              triggerTimeline()
            }
          },
          trigger: `.badge-container`,
          start: `top-=${topOffset} top`,
          end: `+=${contH}`,
          scrub: 1,
        },
      })
    })
  })

  return (
    <HeroContainerMobile>
      <Box width={[220, 220, 340]} mx="auto" pt={[40, 40, 77]}>
        <img src={pill} alt="" role="presentation" />
      </Box>
      <ContainerWithBg
        pt={[40, 40, 77]}
        pb={[32]}
        className="mobile-hero-container"
      >
        <HeroDot ref={dotRef} />
        <HeroDivider />
        {TitleSection}
        <Box
          maxWidth={[288, 288, 524]}
          pt={[72, 72, 120]}
          pb={[80, 80, 144]}
          mx="auto"
        >
          <TextElementNova
            text={subheading}
            element="h2"
            className="Title-20-Super-Normal text-center bg-filter filter-two"
          />
        </Box>
        {ImagesSectionFn(imgRef)}
      </ContainerWithBg>
      <Tabs tabs={tabs} setter={setCoreFade} active={newCore} />
      <Box pt={[24]}>{BenefitsSection}</Box>
    </HeroContainerMobile>
  )
}

export default HeroMobile
